module.exports = __webpack_public_path__ + "static/img/shuiying.0651c92f.png";